import { useState, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { parseUrlFilters } from '../helpers/filterHelpers'

export const useFilters = () => {
  const location = useLocation()

  // Parse initial filters from URL
  const initialFilters = useMemo(() => {
    try {
      return parseUrlFilters(location)
    } catch (error) {
      console.error('Error parsing URL filters:', error)
      return {
        districts: [],
        layouts: [],
        displayOptions: [],
      }
    }
  }, [location])

  // Filter states
  const [districts, setDistricts] = useState(initialFilters.districts)
  const [municipalities, setMunicipalities] = useState(initialFilters.municipalities)
  const [layouts, setLayouts] = useState(initialFilters.layouts)
  const [selectedDisplayOptions, setSelectedDisplayOptions] = useState(initialFilters.displayOptions)
  const [selectedSort, setSelectedSort] = useState('date-desc')
  const [priceRange, setPriceRange] = useState(initialFilters.priceRange)
  const [dateRange, setDateRange] = useState({ start: null, end: null })

  // Keep filter state in sync with direct URL navigation (for example when an
  // alert opens a saved filter set).
  useEffect(() => {
    setDistricts(initialFilters.districts)
    setMunicipalities(initialFilters.municipalities)
    setLayouts(initialFilters.layouts)
    setSelectedDisplayOptions(initialFilters.displayOptions)
    setPriceRange(initialFilters.priceRange)
  }, [initialFilters])

  // Handle layout changes
  const handleLayoutChange = (newLayouts) => {
    setLayouts(newLayouts)
  }

  // Handle display options changes
  const handleDisplayOptionsChange = (newOptions) => {
    setSelectedDisplayOptions(newOptions)
  }

  // Handle price range changes
  const handlePriceRangeChange = (min, max) => {
    const newPriceRange = { min, max }
    setPriceRange(newPriceRange)
  }

  return {
    // Filter states
    districts,
    setDistricts,
    municipalities,
    setMunicipalities,
    layouts,
    setLayouts,
    selectedDisplayOptions,
    setSelectedDisplayOptions,
    selectedSort,
    setSelectedSort,
    priceRange,
    setPriceRange,
    dateRange,
    setDateRange,

    // Handlers
    handleLayoutChange,
    handleDisplayOptionsChange,
    handlePriceRangeChange,
  }
}
